import { store } from "../../store";
import { createCall } from "../base";
import { plainToClass } from "class-transformer";
import { validate } from "class-validator";
import { BASE_METHODS } from "../../constants/enum";
import { CustomErrorType } from "../../constants/action-types";
import { timeoutError } from "../../constants/reducer/base-reducer";
import { CreateDocumentDTO } from "../../constants/dto/document";
import {
  addDocuemnt,
  setDocumentActionStart,
  setDocumentErrorMessage,
} from "../../constants/reducer/document-reducer";

let body: CreateDocumentDTO;

export const creatDocument = async () => {
  store.dispatch(setDocumentActionStart(true));
  const { title, language, file, type } = store.getState().document;

  const params = {
    title,
    language,
    type,
    fileId: file ? file.id : -1,
  };

  await createCall(
    "cms/documents",
    BASE_METHODS.POST,
    "application/json",
    params,
    undefined
  )
    .then(async (response) => {
      try {
        body = plainToClass(
          CreateDocumentDTO,
          JSON.parse(await response.text())
        );
      } catch (error) {
        console.log(error);
        return;
      }
      if ((await validate(body)).length > 0) {
        store.dispatch(
          setDocumentErrorMessage(
            "create-exchange-rate-invalid-response-error-message"
          )
        );
        return;
      }

      store.dispatch(addDocuemnt({ document: body.document }));
    })
    .catch((error) => {
      const errorResponeData: CustomErrorType = error;
      if (errorResponeData) {
        let errorMessage = "";
        switch (errorResponeData.code) {
          case 2001:
            errorMessage = "create-exchange-rate-data-fund-not-exist";
            break;
          case 3001:
            errorMessage = "create-exchange-rate-data-already-exist";
            break;
          default:
            break;
        }
        store.dispatch(setDocumentErrorMessage(errorMessage));
        return;
      }
      store.dispatch(setDocumentActionStart(false));
      store.dispatch(timeoutError());
      return;
    });
};
